module.exports = {
  pathPrefix: `/`,
  url: `http://cakasuma.github.io/amammustofa`,
  title: `Rahdin Ahmad Mustofa Ghaleb Amami`,
  titleTemplate: `%s — My profile`,
  description: `Let's build career together`,
  image: `/images/meta/meta-image.png`, // Path to the default meta image in `static` folder
  siteLanguage: `en`, // Language tag on <html> element

  // Web App Manifest
  favicon: `src/images/favicon.png`, // Used for manifest favicon generation
  shortName: `Amam mustofa`, // shortname for manifest. *Must* be shorter than 12 characters
  themeColor: `#253688`,
  backgroundColor: `#253688`,

  // schema.org JSONLD
  headline: `Let's build career together`,
  author: `Rahdin ahmad mustofa ghaleb amami (cakasuma)`,

  // Google & Twitter
  googleAnalyticsId: `UA-148024361-2`, // Google Analytics ID
  twitter: `@amammustofa`, // Twitter username
}
